import Container from 'components/Container'
import { useLocalization } from 'localization'
import { useUserCurrency } from 'modules/common/hooks'
import { FC, useMemo, useState } from 'react'

import { Typography } from 'antd'
import { useTheme } from 'styled-components'

interface ICurrencyValue {
	currency?: string
	externalAmount?: number
	amount?: number
	valuation?: number
	alwaysShowValuation?: boolean
	showWarning?: boolean
}

const CurrencyValueSimplified: FC<ICurrencyValue> = ({ currency, amount, valuation, alwaysShowValuation = false }) => {
	const { f, fc } = useLocalization()
	const theme = useTheme()
	const fiatCurrency = useUserCurrency()
	const [isFirstError, setIsFirstError] = useState(false)
	const [isSecondError, setIsSecondError] = useState(false)

	const currencySrc = useMemo(
		() =>
			isFirstError
				? `/currencies/${currency?.toLowerCase()}.png`
				: `https://data.wealthica.com/api/securities/CRYPTO:${currency?.toLowerCase()}/logo`,
		[currency, isFirstError]
	)

	if (!amount && amount !== 0) return null

	return (
		<Container display="flex" alignItems="center" space="xs">
			{isSecondError ? (
				<img src="https://app.wealthica.com/images/institutions/undefined.png" width={22} height={22} alt={currency} />
			) : (
				<img
					src={currencySrc}
					width={isFirstError ? 20 : 22}
					height={isFirstError ? 20 : 22}
					onError={() => {
						if (!isFirstError) {
							setIsFirstError(true)
						} else setIsSecondError(true)
					}}
					alt={currency}
				/>
			)}
			<Container display="flex" flexDirection="column" width="100%">
				<Typography.Text ellipsis title={fc(amount, currency)}>
					{fc(amount, currency)}
				</Typography.Text>
				{valuation || alwaysShowValuation ? (
					<Typography.Text style={{ lineHeight: 1, fontSize: theme.typography.sizes.sm }}>
						{f(valuation || 0, { currency: fiatCurrency })}
					</Typography.Text>
				) : undefined}
			</Container>
		</Container>
	)
}

export default CurrencyValueSimplified
